module.exports = __webpack_public_path__ + "static/media/partner.229574f4.svg";